// src\themes\lino\components\animations\textReveal.ts
//
// انیمیشن ورود متن به سبک صفحات محصول اپل (مثل apple.com/iphone-17-pro):
// هر بلوک متن (تیتر، توضیح، دکمه) با کمی فاصله زمانی نسبت به هم، همزمان با
// محو شدن (fade)، بالا آمدن جزئی (translateY) و واضح شدن از حالت تار (blur)
// وارد صفحه می‌شن. این فایل فقط شامل variant های Framer/Motion هست و به‌صورت
// مشترک توی همه‌ی ویجت‌های متن‌دار تم لینو استفاده می‌شه: TextWidget،
// EditorWidget، Banner، ImageWidget، VideoBanner، GridItems،
// StickyStory، Thirdgrid، ThirdGridLine، SwiperList، ProductBar، BannerSlider
// و FullSliderWidget.

// روی والد (گروه متن) قرار می‌گیره تا فرزندهاش رو با تاخیر پشت سر هم انیمیت کنه
export const textGroupVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.35,
            delayChildren: 0.15,
        },
    },
};

// روی هر آیتم متنی (تیتر، پاراگراف، دکمه) قرار می‌گیره
export const textItemVariants = {
    hidden: {
        opacity: 0,
        y: 34,
        filter: 'blur(10px)',
    },
    visible: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        transition: {
            duration: 1.3,
            ease: [0.22, 1, 0.36, 1] as const,
        },
    },
};